'use strict';
var addReferrer, getCurrentUrl, getReturnQuery, getSigninUrl;

addReferrer = function(scope, query) {
  var returnToValue, selector;
  if (scope == null) {
    scope = '';
  }
  if (query == null) {
    query = {};
  }
  selector = '.referrer-link';
  Object.assign(query, {
    metric: 'layout_login'
  });
  returnToValue = getCurrentUrl();
  return $(selector, scope).each(function() {
    var customUrl, key, params, referrer, url, value;
    if (customUrl = this.dataset.returnto) {
      referrer = customUrl;
    } else {
      referrer = returnToValue;
    }
    params = Object.assign({}, query, {
      return_to: referrer
    });
    url = new URL(this.href);
    for (key in params) {
      value = params[key];
      url.searchParams.append(key, value);
    }
    return this.href = url.toString();
  });
};


/**
 * Returns an encoded `return_to` parameter for a link URL
 *
 * @param   {String} url - The url to be added to the return_to param
 * @returns {String}
 */

getReturnQuery = function(str) {
  return encodeURIComponent(str);
};

getCurrentUrl = function() {
  var url;
  url = new URL(location.href);
  url.hash = '';
  url.searchParams["delete"]('ref');
  url.searchParams["delete"]('return_to');
  return url.toString();
};

getSigninUrl = function() {
  var currentUrl;
  currentUrl = getCurrentUrl();
  return "/login?return_to=" + (getReturnQuery(currentUrl));
};


/*
 *  Adds current url as a referrer attribute to user session links
 */

module.exports = {
  addReferrer: addReferrer,
  getCurrentUrl: getCurrentUrl,
  getReturnQuery: getReturnQuery,
  getSigninUrl: getSigninUrl
};

